import Swal from "sweetalert2";
import { append_active_organization_form_data, append_active_organization_id } from "@/utils/organization_profile";

export const my_shop_product_methods = {
    create_product() {
        if (this.validate_item_form()) {
            return;
        }

        const product_type = this.product_types.find(
            (type) => String(type.name || "").toLowerCase() === this.modalType.toLowerCase()
        );

        if (!product_type?.id) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Could not determine product type.",
                position: "bottom-end",
                toast: true,
                showConfirmButton: false,
                timer: 2500,
            });
            return;
        }

        this.isLoading = true;
        const formData = new FormData();
        formData.append("name", this.item_form.name);
        formData.append("price", this.item_form.price);
        formData.append("description", this.item_form.description || "");
        formData.append("base_profile", this.base_profile_id);
        formData.append("product_type_id", product_type.id);
        formData.append("category_id", this.selected_subcategory || "");
        formData.append("attributes", JSON.stringify(this.item_form.attributes || {}));
        append_active_organization_form_data(formData);

        if (this.item_form.service_type_id) {
            formData.append("service_type_id", this.item_form.service_type_id);
        }
        if (this.item_form.service_location) {
            formData.append("location", this.item_form.service_location);
        }
        this.upload_files.forEach((file) => {
            formData.append("media_files", file);
        });

        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_product/`,
            method: "POST",
            headers: {
                Authorization: `Token ${this.getToken()}`,
            },
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
                if (response.status === "success") {
                    const new_product = response.data;
                    this.sync_catalogue_items([...this.profile_products, new_product]);
                    this.reset_product_form();
                    $("#addItemModal").modal("hide");
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Item uploaded successfully!",
                        showConfirmButton: false,
                        timer: 1000,
                        position: "bottom-end",
                        toast: true,
                    });
                    return;
                }

                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: response.message || "Failed to create item.",
                    position: "bottom-end",
                    toast: true,
                    showConfirmButton: false,
                    timer: 2500,
                });
            },
            error: (xhr) => {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: xhr.responseText || "Upload failed.",
                    position: "bottom-end",
                    toast: true,
                    showConfirmButton: false,
                    timer: 2500,
                });
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    },
    open_manage_modal(product) {
        this.modal_product = product;
        this.isEditing = false;
        this.previews = [];
        this.upload_files = [];
        this.active_modal_image_index = 0;
        $("#manageProductModal").modal("show");
    },
    toggle_publish(product) {
        const previous_state = product.is_published;
        product.is_published = !product.is_published;
        const base_profile_id = product?.base_profile_id || product?.base_profile?.id || this.base_profile_id;

        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/publish_product/`,
            method: "POST",
            headers: {
                Authorization: `Token ${this.getToken()}`,
                "Content-Type": "application/json"
            },
            data: JSON.stringify(append_active_organization_id({
                product_id: product.id,
                base_profile_id
            })),
            success: (response) => {
                if (response.status === "success") {
                    product.is_published = response.is_published;
                    this.modal_product = product;
                    return;
                }

                product.is_published = previous_state;
                Swal.fire({
                    icon: "error",
                    text: response.message || "Failed to update product status.",
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                });
            },
            error: (xhr) => {
                product.is_published = previous_state;
                Swal.fire({
                    icon: "error",
                    text: xhr.responseJSON?.message || "Failed to update product status.",
                    position: "bottom-end",
                    showConfirmButton: false,
                    timer: 3000,
                    toast: true,
                });
            }
        });
    },
    edit_product(product) {
        this.isEditing = true;
        this.modal_product = product;
        this.update_item_form = {
            product_id: product.id,
            name: product.name,
            price: product.price,
            description: product.description,
            subcategory_id: product.category?.id || "",
            attributes: {},
            service_type_id: product.service_details?.service_type_id || "",
            service_type: product?.service_details?.type_name,
            location: product?.service_details?.location || ""
        };
        this.selected_category = product.category || "";
        this.fetch_categories();

        if (this.selected_category) {
            this.fetch_subcategories(this.selected_category);
        }

        if (product.attributes?.length) {
            product.attributes.forEach((attr) => {
                const key = attr.attribute_type?.name || attr.attribute_type;
                const cleanKey = key.toLowerCase();

                if (!Reflect.get(this.update_item_form.attributes, cleanKey)) {
                    Reflect.set(this.update_item_form.attributes, cleanKey, []);
                }
                Reflect.get(this.update_item_form.attributes, cleanKey).push(attr.value);
            });
        }

        this.upload_files = [];
        this.previews = [];
        if (product.images?.length) {
            product.images.forEach((img) => {
                this.previews.push({
                    type: "image",
                    src: img.image_url,
                    id: img.id,
                    _delete: false,
                });
            });
        }
    },
    update_product() {
        if (!this.update_item_form.product_id) return;

        this.isLoading = true;
        const formData = new FormData();
        formData.append("product_id", this.update_item_form.product_id);
        formData.append("name", this.update_item_form.name);
        formData.append("price", this.update_item_form.price);
        formData.append("description", this.update_item_form.description);
        formData.append("base_profile_id", this.base_profile_id);
        formData.append("category_id", this.update_item_form.subcategory_id || "");
        formData.append("service_type_id", this.update_item_form.service_type_id || "");
        formData.append("location", this.update_item_form.location || "");
        formData.append("attributes", JSON.stringify(this.update_item_form.attributes || {}));
        append_active_organization_form_data(formData);

        this.upload_files.forEach((file) => formData.append("media_files", file));
        this.previews
            .filter((preview) => preview._delete && preview.id)
            .map((preview) => preview.id)
            .forEach((id) => formData.append("delete_image_ids", id));

        $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_product/`,
            method: "POST",
            headers: {
                Authorization: `Token ${this.getToken()}`,
            },
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
                if (response.status === "success") {
                    const updated_product = response.data;
                    const next_products = [...this.profile_products];
                    const product_index = next_products.findIndex((product) => product.id === updated_product.id);
                    if (product_index !== -1) {
                        next_products.splice(product_index, 1, updated_product);
                    } else {
                        next_products.push(updated_product);
                    }

                    this.sync_catalogue_items(next_products);

                    this.reset_product_form();
                    $("#manageProductModal").modal("hide");
                    Swal.fire({
                        icon: "success",
                        text: "Product updated successfully!",
                        timer: 2000,
                        showConfirmButton: false,
                        position: "bottom-end",
                        toast: true
                    });
                    return;
                }

                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: response.message || "Failed to update product",
                    position: "bottom-end",
                    toast: true,
                    showConfirmButton: false,
                    timer: 2500,
                });
            },
            error: () => {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Failed to update product. Please try again.",
                    position: "bottom-end",
                    toast: true,
                    showConfirmButton: false,
                    timer: 2500,
                });
            },
            complete: () => {
                this.isLoading = false;
            }
        });
    },
    delete_product(product) {
        Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the product!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (!result.isConfirmed) return;

            this.is_deleting = true;
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_product/`,
                method: "POST",
                headers: {
                    Authorization: `Token ${this.getToken()}`,
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(append_active_organization_id({
                    product_id: product.id,
                    base_profile_id: this.base_profile_id
                })),
                success: (response) => {
                    if (response.status === "success") {
                        const deleted_product = response.data;
                        this.sync_catalogue_items(
                            this.profile_products.filter((item) => Number(item.id) !== Number(deleted_product.id))
                        );
                        $("#manageProductModal").modal("hide");
                        Swal.fire({
                            icon: "success",
                            title: "Deleted!",
                            text: "Product has been deleted.",
                            timer: 1200,
                            showConfirmButton: false,
                            position: "bottom-end",
                            toast: true,
                        });
                        return;
                    }

                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: response.message || "Failed to delete product",
                        position: "bottom-end",
                        toast: true,
                        showConfirmButton: false,
                        timer: 2500,
                    });
                },
                error: (xhr) => {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: xhr.responseText || "Failed to delete product",
                        position: "bottom-end",
                        toast: true,
                        showConfirmButton: false,
                        timer: 2500,
                    });
                },
                complete: () => {
                    this.is_deleting = false;
                }
            });
        });
    },
};
